module.exports = __webpack_public_path__ + "media/images/icon/2-506f8f217fbce8ff902f02b68a64b8bd.svg";